// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ready__container___xFxCQ {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
}

.Ready__geometryWrapper___W8ml1 {
    display: flex;
    margin-top: 2.4rem;
    margin-bottom: 0.8rem;
}

.Ready__headTitle___StgCz {
    margin-right: 1rem;
}

.Ready__gridWrapper___h7fY1 .Ready__table___dGI5V {
    grid-template-columns: auto 1fr;
}

.Ready__titleWrapper___CjlUs {
    margin: 0.8rem 1.2rem;
}

.Ready__itemWrapper___dESdM {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
}

.Ready__gridWrapper___h7fY1 {
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/SegyImport/Ready/Ready.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n}\n\n.geometryWrapper {\n    display: flex;\n    margin-top: 2.4rem;\n    margin-bottom: 0.8rem;\n}\n\n.headTitle {\n    margin-right: 1rem;\n}\n\n.gridWrapper .table {\n    grid-template-columns: auto 1fr;\n}\n\n.titleWrapper {\n    margin: 0.8rem 1.2rem;\n}\n\n.itemWrapper {\n    margin-top: 0.8rem;\n    margin-bottom: 0.8rem;\n}\n\n.gridWrapper {\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ready__container___xFxCQ`,
	"geometryWrapper": `Ready__geometryWrapper___W8ml1`,
	"headTitle": `Ready__headTitle___StgCz`,
	"gridWrapper": `Ready__gridWrapper___h7fY1`,
	"table": `Ready__table___dGI5V`,
	"titleWrapper": `Ready__titleWrapper___CjlUs`,
	"itemWrapper": `Ready__itemWrapper___dESdM`
};
export default ___CSS_LOADER_EXPORT___;
